import { useTenantScope } from '../context/TenantScopeContext.jsx';
import './TenantCompanyFilter.css';

/**
 * Filtro global de empresa para súper administrador (misma vista que admin de empresa).
 */
export default function TenantCompanyFilter({ compact = false }) {
    const { isSuperAdmin, tenants, selectedTenantId, setSelectedTenantId, selectedTenantName, needsTenant } =
        useTenantScope();

    if (!isSuperAdmin) return null;

    return (
        <div className={`tenant-co-filter${compact ? ' tenant-co-filter-compact' : ''}`} role="region" aria-label="Filtro por empresa">
            <label className="tenant-co-filter-label" htmlFor="tenant-co-select">
                Ver por empresa
            </label>
            <select
                id="tenant-co-select"
                className="input tenant-co-filter-select"
                value={selectedTenantId}
                onChange={(e) => setSelectedTenantId(e.target.value)}
            >
                {tenants.length === 0 ? (
                    <option value="">Sin empresas registradas</option>
                ) : (
                    tenants.map((t) => (
                        <option key={t.id} value={String(t.id)}>
                            {t.name}
                            {t.is_active === false ? ' (inactiva)' : ''}
                        </option>
                    ))
                )}
            </select>
            {needsTenant ? (
                <span className="tenant-co-filter-warn">Seleccione una empresa para ver los datos del cliente.</span>
            ) : selectedTenantName ? (
                <span className="tenant-co-filter-hint">
                    Vista de: <strong>{selectedTenantName}</strong>
                </span>
            ) : null}
        </div>
    );
}
